<script>
    
    let tel=''
    let fname=''
    let lname=''
    let email=''
    let subject=''
    let message=''
    
    let status=''
    
    const handleSubmit = async()=>{
        const formData = {
          fname,
          lname,
          message,
          subject,
          email,
          tel
        };
        try {
          const response = await fetch('https://bookings.acs-web.co.uk/enquiry', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          });
    
          if (response.ok) {
            console.log('Email sent successfully');
            status='Thank you for your message. Your email has been recieved. We will respond asap.'
          } else {
            console.error('Failed to send data email');
          }
        } catch (error) {
          console.error('Error sending data:', error);
        }
        // console.log(fname + lname + email + tel + message + subject)
    }
    </script>
    
    <main>
        <form class='emailform' on:submit|preventDefault={handleSubmit}>
    
            <input type='text'name ='firstname' placeholder="first name" bind:value={fname}/>
            <input type='text'name ='lastname' placeholder="last name" bind:value={lname}/>
            <input type='text'name ='email' placeholder="email address" bind:value={email}/>
            <input type='text'name ='phone' placeholder="telephone number" bind:value={tel}/>
            <input type='text'name ='subject' placeholder="subject" bind:value={subject}/>
            <textarea rows=6 name='message' placeholder="message" bind:value={message}></textarea>
            <input class="sumbitbtn" type="submit" value="Send message"/>
        </form>
        {status}
    
        <p>Or simply call us:</p>
        <div>☏Phone: 01341 423405</div> 
        <div>📱Mobile : 07786 904895</div>
    </main>
    
    
    <style>
        .emailform{
            display: flex;
            flex-direction: column;
            width: 100%;
            margin: auto;

        }
        input{
            padding:10px;
            margin:10px 0 10px 0;
            font-size:large;
            color: #25272B;
        }
        textarea{
            font-size: large;
            padding:10px;
            color: #25272B;
        }
        .sumbitbtn{
            background-color: rgb(184, 131, 63);
        }
        main{
            display: flex;
            margin: auto;
            flex-direction: column;
            width: 60%;
            justify-content: center;
        }
        @media screen and (max-width: 800px) {
        main {
          width: 94%;
          padding: 10px;
        }
      }
    </style>